import type { RequestInfo } from '@ember-data/request';
import { buildBaseURL, type QueryUrlOptions } from '@warp-drive/utilities';
import { SkipCache } from '@warp-drive/core-types/request';

export function deactivateAccountRequest(accountId: string): RequestInfo {
  const urlOptions: QueryUrlOptions = {
    identifier: { type: 'accounts' },
    op: 'query',
    resourcePath: 'accounts',
  };
  const url = buildBaseURL(urlOptions);
  return {
    url: `${url}/deactivate/${accountId}`,
    method: 'DELETE',
    cacheOptions: {
      [SkipCache]: true,
    },
  };
}

export function updateSnapshotRequest(accountId: string): RequestInfo {
  const urlOptions: QueryUrlOptions = {
    identifier: { type: 'accounts' },
    op: 'query',
    resourcePath: 'accounts',
  };
  const url = buildBaseURL(urlOptions);
  return {
    url: `${url}/${accountId}/update-snapshot`,
    method: 'PATCH',
    cacheOptions: {
      [SkipCache]: true,
    },
  };
}

export function markPaidRequest(accountId: string): RequestInfo {
  const urlOptions: QueryUrlOptions = {
    identifier: { type: 'accounts' },
    op: 'query',
    resourcePath: 'accounts',
  };
  const url = buildBaseURL(urlOptions);
  return {
    url: `${url}/${accountId}/pay-it-off`,
    method: 'POST',
    cacheOptions: {
      [SkipCache]: true,
    },
  };
}

export function createViaProxyRequest(formModel: Record<string, unknown>): RequestInfo {
  const urlOptions: QueryUrlOptions = {
    identifier: { type: 'accounts' },
    op: 'query',
    resourcePath: 'accounts',
  };
  const url = buildBaseURL(urlOptions);
  const body = JSON.stringify(formModel);
  return {
    url: `${url}/proxy`,
    method: 'POST',
    body,
    cacheOptions: {
      [SkipCache]: true,
    },
  };
}
